// Imports => Constants
import { ENDPOINTS } from '@constants';

export class ThemesAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  all() {
    return this.Client.get(ENDPOINTS.THEMES.INDEX)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  single(id) {
    return this.Client.get(`${ENDPOINTS.THEMES.INDEX}/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}

export default ThemesAPI;
